<div class="w-100 mt-0 tool-container">
  <h4>Download Database Spreadsheet</h4>
  <mat-form-field class="me-3">
    <mat-label>Table Name</mat-label>
    <mat-select [(ngModel)]="downloadLifeProducts.table">
      @for (opt of lifeProductTables; track opt) {
        <mat-option [value]="opt">
          {{ opt.display }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="exportLifeProducts()"
    [disabled]="!downloadLifeProducts.table"
  >
    Download
  </button>
  @if (downloadLifeProducts.status) {
    <h4 class="col-12 {{ downloadLifeProducts.statusClass }}">
      {{ downloadLifeProducts.status }}
    </h4>
  }
</div>
